import React from 'react';
import Icon from '../../../components/AppIcon';

const PageHeader = ({ isEditing, memberName, isBlocked }) => {
  return (
    <div className="bg-card border border-border rounded-lg shadow-spiritual-sm p-6 mb-6">
      <div className="flex items-start justify-between">
        <div className="flex items-center space-x-4">
          <div className="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center">
            <Icon 
              name={isEditing ? "UserCheck" : "UserPlus"} 
              size={32} 
              className="text-primary" 
            />
          </div>
          
          <div>
            <h1 className="font-heading font-bold text-2xl text-foreground mb-2">
              {isEditing ? `Edit Member: ${memberName}` : 'Add New Member'}
            </h1>
            <p className="text-muted-foreground">
              {isEditing 
                ? 'Update member information and organizational details'
                : 'Register a new member for seva participation and service allocation'
              }
            </p>
          </div>
        </div>

        <div className="hidden md:flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Clock" size={16} />
          <span>Current Date: {new Date().toLocaleDateString('en-IN')}</span>
        </div>
      </div>

      {isEditing && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center space-x-4 text-sm">
            <div className="flex items-center space-x-2">
              <div className={`w-2 h-2 rounded-full ${isBlocked ? 'bg-destructive animate-pulse' : 'bg-success'}`}></div>
              <span className={`font-medium ${isBlocked ? 'text-destructive' : 'text-muted-foreground'}`}>
                Member Status: {isBlocked ? 'Blocked' : 'Active'}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Calendar" size={14} className="text-muted-foreground" />
              <span className="text-muted-foreground">
                Registered: {new Date(Date.now() - 86400000 * 30).toLocaleDateString('en-IN')}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PageHeader;